import { EVENTS } from '../utils/constants.js'

async function publishUserData(context) {
  const { events, localRepo } = context
  const userData = await localRepo.get()
  if (!userData)
    throw new Error('Publish User Data triggered but Failed to get user data')

  events.dispatch(EVENTS.USER_DATA_AVAILABLE, userData)
}

export default publishUserData
